import "../styling/Explanation.css"

export default function Explanation({ answerSteps, isCorrect }) {
    return (
        <div className="explanation__container">
            {isCorrect && 
                <div className="label--correct">
                    <h1 className="label--correct__text">Correct!</h1>
                </div>
            }

            {!isCorrect &&    
                <div className="label--incorrect">
                    <h1 className="label--incorrect__text">Incorrect!</h1>
                </div>
            }
            
            <div 
                className="explanation" 
                style={{ backgroundColor: isCorrect ? "rgba(71, 221, 128, 0.14)" : "rgba(221, 71, 71, 0.14)" }}
            >
                <h1 className="explanation__title">Explanation</h1>
                {answerSteps.map((str, index) => (
                    <p className="explanation__step" key={index}>{str.replace(/,\s+/g, ',')}</p>
                ))}
            </div>
        </div>
    )
}